package com.banyan.flightviewer.web.components.aircraft

import com.banyan.flightviewer.state.AircraftData

/**
 * Sort keys exposed by the aircraft table header. Match desktop
 * [AircraftTable.kt](desktop/src/main/kotlin/com/banyan/flightviewer/ui/AircraftTable.kt).
 */
enum class SortColumn { CALLSIGN, ORIGIN, DESTINATION, TYPE, DISTANCE, ALTITUDE, SPEED, HEADING, VERT_RATE }

enum class SortDirection { ASC, DESC }

/**
 * Sort an aircraft list by the given column + direction. Distance is always the
 * tiebreaker so rows with equal primary keys stay in "closest first" order --
 * matches desktop feel.
 */
fun sortAircraft(
    list: List<AircraftData>,
    column: SortColumn,
    direction: SortDirection,
): List<AircraftData> {
    val comparator: Comparator<AircraftData> = when (column) {
        SortColumn.CALLSIGN -> compareBy({ it.callsign }, { it.distance })
        SortColumn.ORIGIN -> compareBy({ it.origin }, { it.distance })
        SortColumn.DESTINATION -> compareBy({ it.destination }, { it.distance })
        SortColumn.TYPE -> compareBy({ it.aircraftType }, { it.distance })
        SortColumn.DISTANCE -> compareBy { it.distance }
        SortColumn.ALTITUDE -> compareBy({ it.altitudeNumeric }, { it.distance })
        SortColumn.SPEED -> compareBy({ it.speed }, { it.distance })
        SortColumn.HEADING -> compareBy({ it.heading }, { it.distance })
        SortColumn.VERT_RATE -> compareBy({ it.verticalRate }, { it.distance })
    }
    val sorted = list.sortedWith(comparator)
    return if (direction == SortDirection.DESC) sorted.reversed() else sorted
}
